import React from "react";
import {
    CURRENT_MASTER_DATA_ENDPOINT,
    SAVE_MASTER_DATA_ENDPOINT,
} from "../../../constants/routes";
import Container from "../../../shared/Container";
import Section from "../../../shared/Section";
import P from "../../../shared/typography/P";
import MasterDataWrapper from "./MasterDataWrapper";

const AdminMasterData = () => {
    const endpoint = CURRENT_MASTER_DATA_ENDPOINT;
    const updateEndpoint = SAVE_MASTER_DATA_ENDPOINT;

    return (
        <Section className="pb-4">
            <div className="min-h-[128px] bg-blue-700 lg:hidden"></div>
            <div className="pt-4 pb-2 rounded-3 bg-white -mt-3 lg:mt-0 lg:pt-12 ">
                <Container className="lg:mt-3 lg:shadow-md lg:py-2 xl:py-4 rounded-2 lg:w-9/12">
                    <div className="py-1.5 text-center bg-gray-100 rounded-sm mb-2.4 lg:hidden  ">
                        <P className="font-vietnam">Master Data</P>
                    </div>
                    <MasterDataWrapper
                        endpoint={endpoint}
                        updateEndpoint={updateEndpoint}
                        ref={null}
                        isMasterData={true}
                    />
                </Container>
            </div>
        </Section>
    );
};

export default AdminMasterData;
